import { Button, Card, CardBody } from '@statsbomb/kitbag-components';
import React, { useState } from 'react';
import useApi, { API_ENDPOINTS } from '../../hooks/api';
import usePoll from '../../hooks/poll';

export function Audit() {
  const [message, setMessage] = useState('');
  const api = useApi();

  const getAuditData = async () => {
    await api.get(`${API_ENDPOINTS.videoService}/audit/entries`);
    setTimeout(() => setMessage(''), 1000);
  };

  usePoll(getAuditData, 1000);

  const handleClearAudit = async () => {
    setMessage('Clearing Audit Information');
    await api.delete(`${API_ENDPOINTS.videoService}/audit/entries`);
    setMessage('Audit Cleared');
  };

  const auditMessage = (entry) =>
    `${entry.action} on ${entry.source || 'unknown'} by ${
      entry.user || 'unknown'
    } at ${entry.timestamp} with ${entry.parameters}`;

  const hasEntries =
    api.response &&
    api.response.data &&
    api.response.data.entries &&
    api.response.data.entries.length > 0;

  return (
    <div>
      <h2>Audit Entries</h2>
      <Button variant="secondary" onClick={handleClearAudit}>
        Clear
      </Button>
      <h5>{message}</h5>
      {api.errorMessage && <h5>{api.errorMessage}</h5>}
      <div>
        {hasEntries && (
          <Card>
            <CardBody>
              {api.response?.data?.entries?.map((entry) => auditMessage(entry))}
            </CardBody>
          </Card>
        )}
      </div>
    </div>
  );
}

export default Audit;
